var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBusinessBagSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.4165 7.79183H15.5832V14.1668C15.5832 14.3547 15.5085 14.5349 15.3757 14.6677C15.2429 14.8005 15.0627 14.8752 14.8748 14.8752H2.12484C1.93698 14.8752 1.75681 14.8005 1.62397 14.6677C1.49113 14.5349 1.4165 14.3547 1.4165 14.1668V7.79183ZM12.0415 2.12516H14.8748C15.0627 2.12516 15.2429 2.19979 15.3757 2.33263C15.5085 2.46547 15.5832 2.64563 15.5832 2.8335V6.37516H1.4165V2.8335C1.4165 2.64563 1.49113 2.46547 1.62397 2.33263C1.75681 2.19979 1.93698 2.12516 2.12484 2.12516H4.95817V0.708496H6.37484V2.12516H10.6248V0.708496H12.0415V2.12516Z",
    fill: "#1F7E78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessBagSvg);
export default __webpack_public_path__ + "static/media/BusinessBagSvg.1c889567bedb82ecca75479b0b191fef.svg";
export { ForwardRef as ReactComponent };